import { DefaultRootState } from 'react-redux';

export const selectIsAuthUsed = (state: DefaultRootState) => {
    const { parameters } = state;
    const { getTokensData, getClientDataJws, adAuthUrl } = parameters;
    return Boolean(getTokensData || getClientDataJws || adAuthUrl);
};

export const selectCmsUrl = (state: DefaultRootState) => state.parameters?.cmsUrl?.trim?.() ?? '';
